module.exports = __webpack_public_path__ + "assets/img/third_user_s.c51942e1.svg";